import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from '@/contexts/auth/AuthContext';
import WelcomeBanner from "./WelcomeBanner";
import DepartmentsTabContent from "./DepartmentsTabContent";
import OverviewTabContent from "./OverviewTabContent";
import PlaceholderTabContent from "./PlaceholderTabContent";
import DashboardMetrics from "./DashboardMetrics";
import { Briefcase, TrendingUp, Zap, DollarSign, BarChart3, FileText } from "lucide-react";
import type { DepartmentData } from "./DepartmentsTabContent";

const DashboardPage = () => {
  const { currentOrganization } = useAuth();

  const departmentData: DepartmentData[] = [
    { 
      name: "Operations", 
      icon: Briefcase, 
      taskCount: 12, 
      completedTaskCount: 8, 
      color: "bg-blue-500" 
    },
    { 
      name: "Marketing", 
      icon: TrendingUp, 
      taskCount: 8, 
      completedTaskCount: 5, 
      color: "bg-purple-500" 
    },
    { 
      name: "Engineering", 
      icon: Zap, 
      taskCount: 15, 
      completedTaskCount: 10, 
      color: "bg-green-500" 
    },
    { 
      name: "Sales", 
      icon: DollarSign, 
      taskCount: 10, 
      completedTaskCount: 7, 
      color: "bg-orange-500" 
    },
    { 
      name: "Finance", 
      icon: BarChart3, 
      taskCount: 6, 
      completedTaskCount: 4, 
      color: "bg-red-500" 
    },
    { 
      name: "Legal", 
      icon: FileText, 
      taskCount: 9, 
      completedTaskCount: 6, 
      color: "bg-teal-500" 
    },
  ];

  return (
    <div className="space-y-6 p-6 pb-16">
      <WelcomeBanner />
      
      {currentOrganization && (
        <>
          <DashboardMetrics />
          
          <Tabs defaultValue="overview" className="space-y-4">
            <TabsList>
              <TabsTrigger value="overview">Overview</TabsTrigger>
              <TabsTrigger value="departments">Departments</TabsTrigger>
              <TabsTrigger value="projects">Projects</TabsTrigger>
              <TabsTrigger value="documents">Documents</TabsTrigger>
            </TabsList>
            
            <TabsContent value="overview">
              <OverviewTabContent departmentCount={departmentData.length} />
            </TabsContent>
            
            <TabsContent value="departments">
              <DepartmentsTabContent departmentData={departmentData} />
            </TabsContent>
            
            <TabsContent value="projects">
              <PlaceholderTabContent 
                title="Projects" 
                description="Manage your active projects and track progress" 
              />
            </TabsContent>
            
            <TabsContent value="documents">
              <PlaceholderTabContent 
                title="Documents" 
                description="Shared resources, files, and collaborative documents" 
              />
            </TabsContent>
          </Tabs>
        </>
      )}
    </div>
  );
};

export default DashboardPage;
